import { AODA } from '@core/utilities/aoda';
import { Component, ElementRef, Injector, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { ActivatedRoute } from '@angular/router';
import { Publication } from '@shared/models/records/publication.model';
import { DatabaseIndexNameType } from '@shared/models/common/database-index-name.model';
import { environment } from '@environments/environment';

@Component({
  selector: "app-publication-record",
  templateUrl: "./publication-record.component.html",
  styleUrls: ["./publication-record.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PublicationRecordComponent extends BaseComponent implements OnInit, OnDestroy {
  
  record: Publication;
  searchTerms: string;

  constructor(
    private injector: Injector,
    private route: ActivatedRoute,
    private el: ElementRef,
    private r2: Renderer2
  ) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.loadOntarioExpandCollapse();
    this.initRecord();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
  }

  private initRecord() {
    if (!history.state.data) {
      this.record = JSON.parse(this.searchResultsCache.getRecord());
    } else {
      this.record = history.state.data;
      this.searchTerms = history.state.searchTerms;
      this.searchResultsCache.setRecord(this.record);
    }

    const breadcrumb = {
      name: this.title,
      prefix: "record",
      component: "PublicationRecordComponent",
    };
    this.breadcrumbService.addBreadcrumb(breadcrumb);
  }

  get title() {
    return this.record.title;
  }

  get publicationNumber() {
    return this.record.publ_num;
  }

  get publicationYear() {
    return this.record.year.toString();
  }

  get contributors() {
    return this.record.contributors.sort((a, b) => (a.seniority > b.seniority ? 1 : -1));
  }

  get series() {
    return this.languageService.languageType === 'en' ? this.record.series_en : this.record.series_fr;
  }

  get scale() {
    return this.record.scale;
  }

  get price() {
    return this.record.price.toString();
  }

  get go_files() {
    if (this.record.go_file && this.record.go_file.length > 0) {
      return true;
    }
    return false;
  }

  get townships() {
    return this.record.townships.sort((a, b) => (a.name < b.name ? -1 : 1));
  }

  get nts() {
    return this.record.nts.sort((a, b) => (a.name < b.name ? -1 : 1));
  }

  get rgpDistrict() {
    return this.record.rgp_district.sort((a, b) => (a.name < b.name ? -1 : 1));
  }
  
  get associatedPublications() {
    if (this.record.associated_publications && this.record.associated_publications.length > 0) {
      return true;
    }
    return false;
  }

  get topics() {
    return this.record.topics;
  }

  get abstract() {
    return this.record.abstract;
  }

  get purpose() {
    return this.record.purpose;
  }

  get keywords() {
    return this.record.keywords;
  }

  get databaseIndex(): string {
    return DatabaseIndexNameType.publication;
  }

  get downloadsAZStorage(): string {
    return environment.azure_blob_storage + DatabaseIndexNameType.publication;
  }

  get publicationPersistentLink(): string {
    return environment.application_url + "persistent-linking?" + DatabaseIndexNameType.publication + "=";
  }

}